import React from 'react';
import { Box, IconButton, InputAdornment } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { SelectRaw, TextInputRaw } from '@uplift/ui-v2';

import { useStatesQuery } from '@uplift/queries';


export const ALL_STATES = 'all';


export type SuperviseesFiltersProps = {
  searchText: string;
  onSearchTextChange: (value: string) => void;
  selectedStateId: string;
  onSelectedStateIdChange: (value: string) => void;
  availableStateIds: string[];
};


export const SuperviseesFilters: React.VFC<SuperviseesFiltersProps> = ({
  searchText,
  onSearchTextChange,
  selectedStateId,
  onSelectedStateIdChange,
  availableStateIds,
}) => {
  const { data: states = [] } = useStatesQuery({ suspense: true });
  const stateById = states.reduce((acc, state) => {
    acc[state.id] = state;
    return acc;
  }, {} as Record<string, typeof states[number]>);

  return (
    <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
      <TextInputRaw
        name="search"
        fullWidth
        placeholder="Search providers"
        value={searchText}
        setValue={onSearchTextChange}
        onChange={event => onSearchTextChange(event.target.value)}
        endAdornment={
          searchText ? (
            <InputAdornment position="end">
              <IconButton size="small" onClick={() => onSearchTextChange('')}>
                <CloseIcon fontSize="small" />
              </IconButton>
            </InputAdornment>
          ) : null
        }
      />
      <SelectRaw
        name="state"
        fullWidth={false}
        sx={{ minWidth: 250 }}
        value={selectedStateId}
        onChange={event => onSelectedStateIdChange(event.target.value)}
        items={[
          { value: ALL_STATES, label: 'All States' },
          ...availableStateIds.map(stateId => ({ value: stateById[stateId].id, label: stateById[stateId].fullName })),
        ]}
      />
    </Box>
  );
};
